module.exports = __webpack_public_path__ + "img/tres_puntos.9d080edd.svg";